import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsideLine = _resolveComponent("AsideLine")!
  const _component_Heading3 = _resolveComponent("Heading3")!
  const _component_Note = _resolveComponent("Note")!
  const _component_Heading4 = _resolveComponent("Heading4")!
  const _component_Paragraph = _resolveComponent("Paragraph")!
  const _component_BlockList = _resolveComponent("BlockList")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entities, (entity) => {
    return (_openBlock(), _createElementBlock("article", {
      class: "mb-10 mt-4 flex",
      key: entity.id
    }, [
      _createVNode(_component_AsideLine, { class: "mr-6" }),
      _createElementVNode("div", {
        ref_for: true,
        ref: "periods",
        class: "invisible"
      }, [
        (entity.period)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(entity.period), 1))
          : _createCommentVNode("", true),
        (entity.heading)
          ? (_openBlock(), _createBlock(_component_Heading3, {
              key: 1,
              class: "mb-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(entity.heading), 1)
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (entity.note)
          ? (_openBlock(), _createBlock(_component_Note, {
              key: 2,
              class: "mb-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(entity.note), 1)
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (entity.subheading)
          ? (_openBlock(), _createBlock(_component_Heading4, {
              key: 3,
              class: "mb-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(entity.subheading), 1)
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (entity.description)
          ? (_openBlock(), _createBlock(_component_Paragraph, {
              key: 4,
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(entity.description), 1)
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        _createVNode(_component_BlockList, {
          items: entity.technologies
        }, null, 8, ["items"])
      ], 512)
    ]))
  }), 128))
}